import clsx from 'clsx'

/**
 * Re‑usable loading spinner.
 *
 * Props
 * • size  "xs" | "sm" | "md" | "lg"  (default "md")
 * • className – optional extra classes
 */
export default function Spinner({ size = 'md', className = '' }) {
  const dim = {
    xs: 'h-3 w-3 border-[2px]',
    sm: 'h-4 w-4 border-2',
    md: 'h-6 w-6 border-[3px]',
    lg: 'h-8 w-8 border-4',
  }[size]

  return (
    <span
      className={clsx(
        'inline-block animate-spin rounded-full border-current border-t-transparent',
        'text-charcoal',
        dim,
        className
      )}
      role="status"
      aria-label="loading"
    />
  )
}
